<div class="ui-g-12 p-0 motor-service">
  <div *ngIf="motorVehicleId" class="ui-g-12 p-0 canned-service-browse-content">
    <div class="motor-category-wrapper ui-g-3 p-0">
      <div class="motor-category flex-column">
        <div class="motor-category-item-header flex-between-center pointer" (click)="goBackToCategory()">
          <p class="m-0 category-item-title font-bold">{{ selectedCategory?.Name || 'Categories' }}</p>

          <span [hidden]="!selectedCategory?.SystemID">
            <i class="far fa-arrow-left font-gray-55 p-1"></i>
          </span>
        </div>

        <div class="category-item-wrapper flex-column">
          <div *ngFor="let category of motorCategories" class="flex-start-center motor-category-item"
            [hidden]="selectedCategory?.SystemID"
            [ngClass]="{ 'opacity-40': !systemsCount[category?.SystemID] && query?.length > 2 }"
            (click)="handleSelectCategory(category, systemsCount[category?.SystemID])">
            <p class="m-0 category-item-title pointer" tooltipPosition="top"
              [pTooltip]="setTooltip(systemsCount[category?.SystemID], category?.Name)">
              {{ category?.Name }}
            </p>

            <span *ngIf="query?.length > 2 && !isMotorServiceLoading"> &nbsp;({{ systemsCount[category?.SystemID] || 0
              }}) </span>
          </div>

          <div class="motor-category-item" *ngIf="selectedCategory?.SystemID"
            [ngClass]="{ active: !selectedGroup?.GroupID }"
            (click)="handleSelectGroup(null, systemsCount[selectedCategory?.SystemID])">
            <p class="m-0 category-item-title pointer">
              All <span *ngIf="query?.length > 2 && !isMotorServiceLoading"> ({{
                systemsCount[selectedCategory?.SystemID] || 0 }}) </span>
            </p>
          </div>

          <div *ngFor="let group of selectedCategory?.Groups" class="flex-start-center motor-category-item"
            [hidden]="!selectedCategory?.SystemID"
            [ngClass]="{ active: selectedGroup?.GroupID === group.GroupID, 'opacity-40': !groupsCount[group?.GroupID] && query?.length > 2 }"
            (click)="handleSelectGroup(group, groupsCount[group?.GroupID])">
            <p class="m-0 category-item-title pointer" tooltipPosition="top"
              [pTooltip]="setTooltip(groupsCount[group?.GroupID], group?.Name)">{{ group?.Name }}</p>
            <span *ngIf="query?.length > 2 && !isMotorServiceLoading"> &nbsp;({{ groupsCount[group?.GroupID] || 0 }})
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="ui-g-9 p-0 motor-service-wrapper">
      <div class="flex-column">
        <div class="motor-service-header flex-start-center">
          <p class="m-0 font-bold name">Operational</p>
          <p class="m-0 font-bold labor">Labor</p>
          <p class="m-0 font-bold part">Parts</p>
          <p class="m-0 font-bold fluid">Fluids</p>
          <p class="m-0 font-bold subtotal">Subtotal</p>
          <p class="m-0 font-bold estimate" *ngIf="!isServiceLookup">Add to Estimate</p>
        </div>

        <div class="motor-service-item-wrapper width-100p flex-column">
          <div class="flex-center-center motor-app-loading" [hidden]="!isMotorServiceLoading">
            <span class="pr-2">Loading</span>
            <i class="fal fa-spinner rotate"></i>
          </div>

          <div class="flex-center-center motor-app-loading flex-column"
            [hidden]="selectedCategory?.SystemID || applications.length || isMotorServiceLoading || !motorCategories?.length">
            <img src="../../../../assets/img/motor-category-empty-icon.svg" alt="" />
            <div class="pr-2 font-12 pt-2">Select a category to view items</div>
          </div>

          <div class="flex-center-center motor-app-loading flex-column"
            [hidden]="selectedCategory?.SystemID || applications.length || isMotorServiceLoading || motorCategories?.length">
            <i class="fal fa-sad-tear no-motor-service-found"></i>

            <p class="mb-0 pr-2 font-14 pt-2 flex-center-center flex-column">
              <span>Oh no! Looks like we are not able to find any results from OEM.</span>
              <span>Feel free to reach out to our support for more details.</span>
            </p>
          </div>

          <div *ngFor="let application of applications; let applicationIndex = index"
            class="motor-service-item flex-column flex-center-start" listItemLabel="title"
            [hidden]="isMotorServiceLoading">
            <app-accordian listItemKey="items" listItemLabel="" [confirmationTitle]="confirmationTitle"
              [confirmationContent]="confirmationContent" listItemIdKey="itemSourceId" dataIdKey="SApplicationID"
              [showConfirmDeselectModal]="true" [data]="application" [hasItemCheckbox]="true" [iconSize]="10"
              [fontSize]="12" [index]="applicationIndex" [hasCustomHeader]="true" [hasAccordianSubItem]="true"
              [hasAccordianSubItemCheckbox]="true" [hasQuantityChanged]="hasQuantityChanged"
              (handleItemSelectChange)="handleSelectChangeMotor($event, application)"
              (appOnExpand)="handleExpandMotorService($event, application)" (handleReset)="handleReset($event)">
              <ng-template appTemplate="accordian-header" let-selectAll="selectAll">
                <div class="flex-between-center service-acc-header"
                  (click)="addToEstmateMotor(application, selectedMotorServices[application.SApplicationID]?.extra?.isAdded, selectAll, $event, true, applicationIndex)">
                  <div class="flex-start-start name">
                    <div class="motor-service-name-wrapper flex-column flex-start-start">
                      <span class="motor-service-name text-truncate font-13 font-600"
                        [ngClass]="{ 'width-200px': !isRepairDiagramEnabled }" [pTooltip]="application?.DisplayName">
                        {{ application?.DisplayName }}
                      </span>

                      <span class="motor-service-name text-truncate font-12"
                        [ngClass]="{ 'width-200px': !isRepairDiagramEnabled }" [pTooltip]="application?.subheading">
                        {{ application?.subheading }}
                      </span>
                    </div>

                    <i *ngIf="isRepairDiagramEnabled" class="fal fa-file-invoice flex-center-center repair-diagram-icon"
                      (click)="openRepairDiagram(application, $event)"></i>
                  </div>

                  <div class="flex-center-start font-12 m-width-65 flex-column mr-1 labor">
                    <span>
                      {{ application?.serviceTotal?.labor || 0 | currency: usd }}
                    </span>

                    <span class="flex-center-center">
                      <i class="far fa-clock fa-icon-light-gray pr-2"></i>
                      {{ application?.count?.labor || 0 | number: '1.2-2' }}
                    </span>
                  </div>

                  <!-- Part -->
                  <div class="flex-center-start font-12 m-width-65 flex-column part">
                    <span>
                      {{ application?.serviceTotal?.parts || 0 | currency: usd }}
                    </span>

                    <span class="flex-center-center">
                      <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                      {{ application?.count?.parts || 0 | number: '1.2-2' }}
                    </span>
                  </div>

                  <!-- Tire -->
                  <div class="flex-center-start font-12 m-width-65 flex-column fluid">
                    <span>
                      {{ application?.serviceTotal?.fluids || 0 | currency: usd }}
                    </span>

                    <span class="flex-center-center">
                      <i class="far fa-list-alt fa-icon-light-gray pr-2"></i>
                      {{ application?.count?.fluids || 0 | number: '1.2-2' }}
                    </span>
                  </div>

                  <div class="flex-center-start font-12 m-width-65 flex-column subtotal">
                    <span>
                      {{ application?.serviceTotal?.total || 0 | currency: usd }}
                    </span>

                    <span class="flex-center-center invisible">
                      <i class="far fa-ballot-check fa-icon-light-gray pr-2"></i>
                      {{ application?.inspection != undefined ? 1 : 0 }}
                    </span>
                  </div>

                  <div id="btn-selected-est{{ applicationIndex }}"
                    *ngIf="selectedMotorServices[application.SApplicationID] && !isServiceLookup"
                    class="text-center estimate">
                    <div class="font-11 pointer add-est-btn btn-gray">
                      Selected
                    </div>
                  </div>

                  <div id="btn-add-est{{ applicationIndex }}"
                    *ngIf="!selectedMotorServices[application.SApplicationID] && !isServiceLookup"
                    class="text-center estimate">
                    <div class="font-11 pointer add-est-btn btn-white">
                      Add
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-template let-item let-checkboxId="checkboxId" appTemplate="accordian-sub-item">
                <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
                  <div class="flex-start-start font-12">
                    <p class="m-0 flex-column width-370px">
                      <span class="pl-2 text-truncate width-480px" [pTooltip]="item.title">{{ item.title }}</span>
                      <span class="pl-2 text-truncate width-480px" [pTooltip]="item.subheading">
                        {{ item.subheading }}
                      </span>
                    </p>
                  </div>

                  <div class="motor-line-item-total flex-start-center">
                    <!-- Default hours -->
                    <div class="default-hours flex-column">
                      <div class="flex-start-center font-11 font-secondary-800 position-relative">
                        <i *ngIf="item.type === 'labor'" class="far fa-clock font-gray-45 pr-1"></i>
                        <i *ngIf="item.type === 'fluids'" class="far fa-list-alt font-gray-45 pr-1"></i>
                        <i *ngIf="item.type === 'parts'" class="far fa-tools font-gray-45 pr-1"></i>
                        <span class="motor-m" *ngIf="item.type === 'labor'"></span>
                        {{ item.actualLaborTime }}
                      </div>
                      <div class="flex-start-center font-9 font-gray-35 motor-duration">MOTOR {{ item.type === 'fluids'
                        ? units.fluids[item.unitOfMeasuring] : units[item.type] }}</div>
                    </div>

                    <!-- Current hours -->
                    <div class="mr-2">
                      <div class="flex-start-center position-relative hours-input">
                        <app-input class="width-80px" placeholder="0" theme="border" styleClassInput="pl-0"
                          styleClass="pl-2 bg-color-white" [fontSize]="12"
                          [allowDecimal]="focus[application.SApplicationID + '' + item.itemSourceId] ? true : false"
                          [selectTextOnFocus]="true" [disabled]="!selectedMotorServices[application.SApplicationID]"
                          [value]="focus[application.SApplicationID + '' + item.itemSourceId] ? item.count : (item.count | number: '1.2-2')"
                          (appClickInput)="handleInputClick(item, !selectedMotorServices[application.SApplicationID])"
                          (appFocus)="handleFocus(application.SApplicationID + '' + item.itemSourceId, !selectedMotorServices[application.SApplicationID])"
                          (appBlur)="handleBlur(application.SApplicationID, item.itemSourceId, applicationIndex)"
                          (appKeyUp)="handleChange(application.SApplicationID, item.itemSourceId, $event)">
                        </app-input>

                        <i *ngIf="item?.type === 'labor' && numberObj((application?.defaultItemCount)[item.itemSourceId]) !== numberObj((application?.itemCount)[item.itemSourceId])"
                          class="fal fa-undo pointer undo-marked-up"
                          [pTooltip]="showTooltip(item.actualLaborTime, item.motorMarkup, (application?.defaultItemCount)[item.itemSourceId])"
                          (click)="handleRevertManualHour(application.SApplicationID, item.itemSourceId, numberObj((application?.defaultItemCount)[item.itemSourceId]), applicationIndex, $event)"></i>

                        <div class="text-wrapper-motor">
                          <span class="hrs">
                            {{ item.type === 'fluids' ? units.fluids[item.unitOfMeasuring] : units[item.type] }}
                          </span>

                          <span *ngIf="item?.type === 'labor'" class="hrs-text text-truncate" style="max-width: 75px;">
                            {{ numberObj((application?.defaultItemCount)[item.itemSourceId]) ===
                            numberObj((application?.itemCount)[item.itemSourceId]) ? 'Marked up' : 'Manually entered' }}
                          </span>

                          <span *ngIf="item?.type !== 'labor'" class="hrs-text text-truncate" style="max-width: 75px;">
                            MOTOR qty
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="flex-column mr-2 width-55px">
                      <div class="font-12 text-right font-600 font-gray">
                        {{ item.subTotal | currency: usd }}
                      </div>

                      <div class="font-9 text-right font-gray flex-column">
                        <span>{{ item?.quantity }}</span>
                      </div>
                    </div>
                  </div>
                </label>
              </ng-template>

              <ng-template appTemplate="accordian-footer">
                <p class="flex-center-center m-0 pt-1 pb-1 pr-2 pl-2"
                  [hidden]="!motorIncludedOperationLoading[application.SApplicationID] || !motorIncludedServices[application.SApplicationID]?.length">
                  <span class="pr-2">Loading</span>
                  <i class="fal fa-spinner rotate"></i>
                </p>

                <div class="flex-column optional-service included-service-wrapper"
                  *ngIf="motorIncludedServices[application.SApplicationID] && motorIncludedServices[application.SApplicationID].length">
                  <p class="m-0 p-2 font-bold font-11 optional-service-header">INCLUDED OPERATIONS</p>

                  <div *ngFor="let includedOperation of motorIncludedServices[application.SApplicationID] || []"
                    class="m-0 included-service">
                    {{ includedOperation?.displayName }}
                  </div>
                </div>

                <p class="flex-center-center m-0 pt-1 pb-1 pr-2 pl-2"
                  [hidden]="!motorAdditionalServiceLoading[application.SApplicationID] || !application?.OptionalWorkTimes?.length">
                  <span class="pr-2">Loading</span>
                  <i class="fal fa-spinner rotate"></i>
                </p>

                <div class="flex-column optional-service"
                  *ngIf="additionalCannedServices[application.SApplicationID] && additionalCannedServices[application.SApplicationID].length">
                  <p class="m-0 p-2 font-bold font-11 optional-service-header">OPTIONAL SERVICES</p>

                  <div
                    *ngFor="let additionService of additionalCannedServices[application.SApplicationID]; let additionServiceIndex = index"
                    class="">
                    <div *ngIf="!!additionService">
                      <app-accordian listItemKey="items" listItemLabel="" [confirmationTitle]="confirmationTitle"
                        [confirmationContent]="confirmationContent" listItemIdKey="itemSourceId"
                        dataIdKey="SApplicationID" [showConfirmDeselectModal]="true" [data]="additionService"
                        [hasItemCheckbox]="true" [iconSize]="10" [fontSize]="12" [index]="additionServiceIndex"
                        [hasCustomHeader]="true" [hasAccordianSubItem]="true" [hasAccordianSubItemCheckbox]="true"
                        [hasQuantityChanged]="hasQuantityChanged"
                        (handleItemSelectChange)="handleSelectChangeMotor($event, additionService)"
                        (appOnExpand)="handleExpandMotorService($event, additionService)"
                        (handleReset)="handleReset($event)">
                        <ng-template appTemplate="accordian-header" let-selectAll="selectAll">
                          <div class="flex-between-center service-acc-header"
                            (click)="addToEstmateMotor(additionService, selectedMotorServices[additionService.SApplicationID]?.extra?.isAdded, selectAll, $event, true, additionServiceIndex, true)">
                            <div class="flex-start-start name">
                              <div class="motor-service-name-wrapper flex-column flex-start-start">
                                <span class="motor-service-name text-truncate font-13 font-600"
                                  [ngClass]="{ 'width-200px': !isRepairDiagramEnabled }"
                                  [pTooltip]="additionService?.DisplayName">
                                  {{ additionService?.DisplayName }}
                                </span>

                                <span class="motor-service-name text-truncate font-12"
                                  [ngClass]="{ 'width-200px': !isRepairDiagramEnabled }"
                                  [pTooltip]="application?.subheading">
                                  {{ additionService?.subheading }}
                                </span>
                              </div>

                              <i *ngIf="isRepairDiagramEnabled"
                                class="fal fa-file-invoice flex-center-center repair-diagram-icon"
                                (click)="openRepairDiagram(additionService, $event)"></i>
                            </div>

                            <div class="flex-center-start font-12 m-width-65 flex-column mr-1 labor">
                              <span>
                                {{ additionService?.serviceTotal?.labor || 0 | currency: usd }}
                              </span>

                              <span class="flex-center-center">
                                <i class="far fa-clock fa-icon-light-gray pr-2"></i>
                                {{ additionService?.count?.labor || 0 | number: '1.2-2' }}
                              </span>
                            </div>

                            <!-- Part -->
                            <div class="flex-center-start font-12 m-width-65 flex-column part">
                              <span>
                                {{ additionService?.serviceTotal?.parts || 0 | currency: usd }}
                              </span>

                              <span class="flex-center-center">
                                <i class="far fa-tools fa-icon-light-gray pr-2"></i>
                                {{ additionService?.count?.parts || 0 | number: '1.2-2' }}
                              </span>
                            </div>

                            <!-- Tire -->
                            <div class="flex-center-start font-12 m-width-65 flex-column fluid">
                              <span>
                                {{ additionService?.serviceTotal?.fluids || 0 | currency: usd }}
                              </span>

                              <span class="flex-center-center">
                                <i class="far fa-list-alt fa-icon-light-gray pr-2"></i>
                                {{ additionService?.count?.fluids || 0 | number: '1.2-2' }}
                              </span>
                            </div>

                            <div class="flex-center-start font-12 m-width-65 flex-column subtotal">
                              <span>
                                {{ additionService?.serviceTotal?.total || 0 | currency: usd }}
                              </span>

                              <span class="flex-center-center invisible">
                                <i class="far fa-ballot-check fa-icon-light-gray pr-2"></i>
                                {{ additionService?.inspection != undefined ? 1 : 0 }}
                              </span>
                            </div>

                            <div id="btn-selected-est{{ additionServiceIndex }}"
                              *ngIf="selectedMotorServices[additionService.SApplicationID] && !isServiceLookup"
                              class="font-11 pointer add-est-btn btn-gray text-center estimate">
                              Selected
                            </div>

                            <div id="btn-add-est{{ additionServiceIndex }}"
                              *ngIf="!selectedMotorServices[additionService.SApplicationID] && !isServiceLookup"
                              class="text-center estimate">
                              <div class="font-11 pointer add-est-btn btn-white">
                                Add
                              </div>
                            </div>
                          </div>
                        </ng-template>

                        <ng-template let-item let-checkboxId="checkboxId" appTemplate="accordian-sub-item">
                          <label class="flex-between-center width-100p mb-0 pointer" [for]="checkboxId">
                            <div class="flex-start-start font-12">
                              <p class="m-0 flex-column">
                                <span class="pl-2 text-truncate width-480px" [pTooltip]="item.title">{{ item.title
                                  }}</span>
                                <span class="pl-2 text-truncate width-480px" [pTooltip]="item.subheading">{{
                                  item.subheading }}</span>
                              </p>
                            </div>

                            <div class="motor-line-item-total flex-between-center">
                              <!-- Default hours -->
                              <div class="default-hours flex-column">
                                <div class="flex-start-center font-11 font-secondary-800 position-relative">
                                  <i *ngIf="item.type === 'labor'" class="far fa-clock font-gray-45 pr-1"></i>
                                  <i *ngIf="item.type === 'fluids'" class="far fa-list-alt font-gray-45 pr-1"></i>
                                  <i *ngIf="item.type === 'parts'" class="far fa-tools font-gray-45 pr-1"></i>
                                  <span class="motor-m" *ngIf="item.type === 'labor'"></span>
                                  {{ item.actualLaborTime }}
                                </div>
                                <div class="flex-start-center font-9 font-gray-35">MOTOR {{ item.type === 'fluids' ?
                                  units.fluids[item.unitOfMeasuring] : units[item.type] }}</div>
                              </div>

                              <div class="mr-2">
                                <div class="flex-start-center position-relative hours-input">
                                  <app-input class="width-80px" placeholder="0" theme="border" styleClassInput="pl-0"
                                    styleClass="pl-2 bg-color-white" [fontSize]="12"
                                    [allowDecimal]="focus[additionService.SApplicationID + '' + item.itemSourceId] ? true : false"
                                    [selectTextOnFocus]="true"
                                    [disabled]="!selectedMotorServices[additionService.SApplicationID]"
                                    [value]="focus[additionService.SApplicationID + '' + item.itemSourceId] ? item.count : (item.count | number: '1.2-2')"
                                    (appClickInput)="handleInputClick(item, !selectedMotorServices[additionService.SApplicationID])"
                                    (appFocus)="handleFocus(additionService.SApplicationID + '' + item.itemSourceId, !selectedMotorServices[additionService.SApplicationID])"
                                    (appBlur)="handleBlur(additionService.SApplicationID, item.itemSourceId, additionServiceIndex, true, application.SApplicationID)"
                                    (appKeyUp)="handleChange(additionService.SApplicationID, item.itemSourceId, $event, true, additionService.SApplicationID)">
                                  </app-input>

                                  <i *ngIf="item?.type === 'labor' && numberObj((additionService?.defaultItemCount)[item.itemSourceId]) !== numberObj((additionService?.itemCount)[item.itemSourceId])"
                                    class="fal fa-undo pointer undo-marked-up"
                                    [pTooltip]="showTooltip(item.actualLaborTime, item.motorMarkup, (additionService?.defaultItemCount)[item.itemSourceId])"
                                    (click)="
                                      handleRevertManualHour(
                                        additionService.SApplicationID,
                                        item.itemSourceId,
                                        numberObj((additionService?.defaultItemCount)[item.itemSourceId]),
                                        additionServiceIndex,
                                        $event
                                      )
                                    "></i>

                                  <div class="text-wrapper-motor">
                                    <span class="hrs">
                                      {{ item.type === 'fluids' ? units.fluids[item.unitOfMeasuring] : units[item.type]
                                      }}
                                    </span>
                                    <span *ngIf="item?.type === 'labor'" class="hrs-text text-truncate"
                                      style="max-width: 75px;">
                                      {{
                                      numberObj((additionService?.defaultItemCount)[item.itemSourceId]) ===
                                      numberObj((additionService?.itemCount)[item.itemSourceId])
                                      ? 'Marked up'
                                      : 'Manually entered'
                                      }}
                                    </span>

                                    <span *ngIf="item?.type !== 'labor'" class="hrs-text text-truncate"
                                      style="max-width: 75px;">
                                      MOTOR qty
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="flex-column mr-2 width-55px">
                                <div class="font-12 text-right font-600 font-gray">
                                  {{ item.subTotal | currency: usd }}
                                </div>
                                <div class="font-9 text-right font-gray">{{ item.quantity }}</div>
                              </div>
                            </div>
                          </label>
                        </ng-template>
                      </app-accordian>
                    </div>
                  </div>
                </div>
              </ng-template>
            </app-accordian>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!motorVehicleId" class="ui-g-12 p-0 canned-service-browse-content">
    <div class="flex-center-center motor-unlink-canned-service flex-column">
      <img src="../../../../assets/img/motor-unlink-icon.svg" alt="" />
      <div class="pr-2 font-12 pt-2 font-gray-35" *ngIf="isServiceLookup">Search vehicle to view services</div>
      <div class="pr-2 font-12 pt-2 font-gray-35" *ngIf="!isServiceLookup">Connect vehicle with MOTOR to view items
      </div>
    </div>
  </div>
</div>
